module.exports = __webpack_public_path__ + "img/blind.3021cc18.svg";